import { orchestrator } from 'satcheljs';
import { logInlineFeedbackDialogResponse } from '../actions/logInlineFeedbackDialogResponse';
import getCategoriesToLog, { CategoriesToLog } from '../utils/getCategoriesToLog';
import { CaptureFeedbackDatapoint } from 'owa-feedback-common';

export default orchestrator(logInlineFeedbackDialogResponse, async dialogResponse => {
    const keys: string[] = ['fdsid', 'fdt', 'fdc', 'fdicd', 'fduvt', 'fdodsr'];
    const categories: CategoriesToLog[] = getCategoriesToLog(dialogResponse);

    let values: string[] = [
        dialogResponse.sessionId,
        dialogResponse.inlineFeedbackResponseText,
        JSON.stringify(categories),
        dialogResponse.isContentDonated ? 'Yes' : 'No',
        dialogResponse.isUVTicketCreated ? 'Yes' : 'No',
        dialogResponse.odsResponse,
    ];

    await CaptureFeedbackDatapoint.import().then(captureFeedbackDatapoint => {
        captureFeedbackDatapoint({
            keys: keys,
            values: values,
        });
    });
});
